import { useAppSettingStore } from '../store/app-store';
import { useAuth } from './use-auth';
import { getNextPageParam, getPreviousPageParam } from '@/libs/react-sdk/utils';
import { ApiInstance, UserNotificationsParams } from '@/libs/sdk/api';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

export const useSignedNotifications = (api: ApiInstance, params?: Partial<UserNotificationsParams>) => {
  const { data } = useAuth();
  const uid = data?.uid;
  const baseToken = useAppSettingStore(state => state.baseToken);
  const { page = 1, pageSize = 10, baseTokenAddress = baseToken.address } = params || {};
  const query = useInfiniteQuery({
    enabled: !!uid,
    queryKey: ['SignedNotifications', uid, page, pageSize, baseTokenAddress, params],
    initialPageParam: { page, pageSize },
    queryFn: async ({ signal, pageParam }) => {
      const { data } = await api.user.getUserNotifications({ baseTokenAddress, ...params, ...pageParam }, { signal });
      return {
        ...data,
        ...pageParam,
      };
    },
    placeholderData: keepPreviousData,
    getPreviousPageParam,
    getNextPageParam,
  });
  useEffect(() => {
    if (!query.isEnabled) return;
    const reftch = () => query.refetch({ cancelRefetch: false });
    api.sse.addEventListener('user:new_notification', reftch);
    return () => {
      api.sse.removeEventListener('user:new_notification', reftch);
    };
  }, [query.isEnabled, api.sse]);
  return query;
};
